import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';

@Component({
  selector: 'app-print-noc',
  templateUrl: './print-noc.component.html',
  styleUrls: ['./print-noc.component.scss']
})
export class PrintNocComponent implements OnInit {
  appVerificationItems: MenuItem[];
  public userId: any;
  public userRidList: any = [];
  public selectedApplications: any[];
  public subscriptions: any = [];
  public subjectSub: any;
  public loading: boolean = false;

  constructor(
    private deptDashBoardService: DepartmentDashboardService,
    private loader: AppLoaderService,
    private messageService: MessageService, 
    private router: Router,
    private cryptoJsService: CryptoJsService
  ) { }

  ngOnInit(): void {
   

    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

    this.loadData();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if (this.subjectSub) {
      this.subjectSub.unsubscribe();
    }
  }


  loadData() {
    this.loader.start();
    let sub = this.deptDashBoardService
      .GetUhbvnNOCPathByXEN(this.userId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (`${data}`?.length > 0) {
            this.userRidList = data;
          } else {
            this.userRidList = [];

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: `Data Not Available`,
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.userRidList = [];
          this.messageService.add({
            severity: 'info',
            summary: 'Info Message',
            detail: `${err}`,
          });
        },
      });

    this.subscriptions.push(sub);
  }
  onClickApp(appId) {
    // let statusCodeEncrypted = this.cryptoJsService.Encrypt(this.statusCode);
    const link = this.router.serializeUrl(this.router.createUrlTree(['xen', 'print', appId]));
    window.open(link, '_blank');
  }
}
